// extracted by mini-css-extract-plugin
export var header = "_sm-1";
export var maskBottom = "_sm-6";
export var maskMiddle = "_sm-7";
export var maskTop = "_sm-5";
export var root = "_sm-0";
export var scrollDownButton = "_sm-3";
export var scrollDownButtonHidden = "_sm-4";
export var viewport = "_sm-2";